<template>
  <div class="policy-checkbox policy-checkbox_dark" :class="this.class">
    <div class="policy-checkbox__inner">
      <input type="checkbox"
             :id="id + '-agreement'"
             required
             value="152"
             style="opacity: 0;"
             :checked="modelValue"
             @input="handleInput($event)"
      >

      <label :for="id + '-agreement'"
             class="small-label">
        Я&nbsp;даю
        <a :href="documents.agreementFileRoute"
           target="_blank"
           rel="nofollow noopener noreferrer"
           class="policy-checkbox__policy-link"
        >
          согласие
        </a>
         на&nbsp;обработку моих персональных данных на условиях

        <a :href="documents.policyFileRoute"
           target="_blank"
           rel="nofollow noopener noreferrer"
           class="policy-checkbox__policy-link"
        >
          Политики обработки
        </a>
        персональных данных
      </label>

      <div class="policy-checkbox__error" :class="{_visible: errors.policyCheckbox}">
        <NotificationIcon/>
        <div class="policy-checkbox__error-title text__mini">
          Чтобы продолжить, установите этот флажок
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NotificationIcon from "../../icons/NotificationIcon.vue";
  import {mapMutations, mapState} from "vuex";

  export default {
    name: "policy-checkbox",
    components: {NotificationIcon},
    props: {
      id: {
        type: String,
        require: true,
      },
      modelValue: {
        type: Boolean,
        require: true,
      },
      documents: {
        type: Object,
        required: false
      },
      class: {
        type: String,
        required: false
      }
    },
    computed: {
      ...mapState('order', {
        'errors': 'errors',
      }),
    },
    methods: {
      ...mapMutations('order', ['clearError']), // Маппим мутацию для очистки ошибки
      handleInput(event) {
        const isChecked = event.target.checked;
        // Обновляем v-model
        this.$emit('update:modelValue', isChecked);

        if (isChecked) {
          this.clearError('policyCheckbox');
        }
      }
    }
  }
</script>

<style scoped>

</style>